import React from 'react';

const HomeAboutSection = () => {
  return (
    <section id="about" aria-labelledby="about-title" className="site-bg-section py-20 px-6">
      <div className="container mx-auto text-center max-w-3xl">
        <h2
          id="about-title"
          className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
        >
          About Me
        </h2>
        <p className="mt-6 text-lg text-gray-600">
          Bem-vindo(a) ao meu espaço pessoal na web! Sou um desenvolvedor apaixonado por tecnologia.
          Aqui você encontrará uma coleção dos meus projetos, reflexões sobre tecnologia e um pouco
          da minha trajetória no mundo do desenvolvimento de software.
        </p>
      </div>
    </section>
  );
};

export default HomeAboutSection;
